{
    "subjectCategories": {
        "title": "Subject Categories",
        "description": "Categories control subject availability for every tutor and student. Existing practices and results remain accessible. Enter a reason before changing a category.",
        "names": {
            "PRIMARY": "Primary School",
            "SECONDARY": "Secondary School",
            "BILINGUAL": "Bilingual Schools",
            "TECHNICAL": "Technical High Schools"
        },
        "reason": "Reason for this change",
        "saving": "Saving global configuration…",
        "saved": "Global category configuration saved.",
        "error": "Category configuration could not be saved. Check the current values and try again.",
        "empty": "No active subjects are available.",
        "unmapped": "Active subjects without categories remain available for compatibility. Review these codes: {0}.",
        "countOne": "1 subject",
        "countOther": "{0} subjects",
        "other": "Other subjects",
        "membershipHelp": "Assign this subject to one or more categories. Each tutor chooses which categories and subjects appear when creating practices."
    },
    "marketing": {
        "nav": {
            "product": "How it works",
            "pricing": "Pricing",
            "contact": "Contact",
            "home": "Athena, go to the home page",
            "primary": "Main navigation"
        },
        "hero": {
            "eyebrow": "PRACTICES FOR TUTORS AND STUDENTS",
            "title": "Create practices from your material. Follow every step.",
            "description": "Turn your study material into practices with AI, review them and assign them to your students. They answer from their own accounts; you use their results to decide what to review next.",
            "cta": "Start for free",
            "secondary": "See how it works",
            "note": "You can also create practices manually.",
            "tag": "LEARN. PRACTICE. MOVE FORWARD."
        },
        "preview": {
            "label": "Athena product tour: create, assign and complete a practice"
        },
        "steps": {
            "eyebrow": "HOW ATHENA WORKS",
            "title": "Connect with your students on Athena.",
            "description": "Tutors and students each have their own account. The tutor sends a connection request, and the student accepts it in Athena to receive practices.",
            "sequenceLabel": "Six steps from creating accounts to assigning practices",
            "roles": {
                "tutor": "TUTOR",
                "student": "STUDENT",
                "connected": "CONNECTED"
            },
            "tutorAccount": {
                "title": "The tutor creates an account",
                "body": "The tutor signs up to prepare practices, support students and follow their progress."
            },
            "studentAccount": {
                "title": "The student creates an account",
                "body": "The student signs up for their own space to receive and complete practices."
            },
            "invitation": {
                "title": "The tutor sends a request",
                "body": "The tutor sends a connection request to the student."
            },
            "acceptInvitation": {
                "title": "The student accepts in Athena",
                "body": "The student reviews tutor requests in their account and chooses whether to accept or decline."
            },
            "assignPractice": {
                "title": "The tutor assigns practices",
                "body": "Once their accounts are connected, the student receives assigned practices and the tutor can review their results."
            }
        },
        "benefits": {
            "eyebrow": "SUPPORT EVERY STEP",
            "title": "More clarity for you. More independence for them.",
            "family": {
                "title": "Everything in one place",
                "body": "Prepare and assign practices, manage your students and review their results from your tutor account."
            },
            "independence": {
                "title": "A space of their own",
                "body": "Students work from their own accounts and can save their progress to continue later, within the time allowed for the practice."
            },
            "clarity": {
                "title": "See what needs more practice",
                "body": "Check scores and use the results to decide what to review next."
            }
        },
        "pricing": {
            "eyebrow": "A PLAN FOR EVERY STAGE",
            "title": "Choose a plan for your practices.",
            "description": "Start for free and choose a plan with more capacity when you need it. Students don't need a subscription.",
            "compareTitle": "Compare plans",
            "compareDescription": "What each plan includes. Students never need a plan of their own.",
            "freeDescription": "Start with one student.",
            "premiumDescription": "Work with more students and practices.",
            "plusDescription": "More capacity for practices and AI creation.",
            "periodLabel": "Billing period",
            "periodMonthly": "1 month",
            "periodQuarterly": "3 months",
            "periodAnnual": "Annual",
            "recommended": "Recommended",
            "pricePerMonth": "/ month",
            "pricePerQuarter": "/ 3 months",
            "pricePerYear": "/ year",
            "periodAnnouncement": "{0} selected. Premium {1}; Premium Plus {2}.",
            "studentsOne": "Up to {0} student",
            "studentsOther": "Up to {0} students",
            "practices": "{0} active practices",
            "practicesUnlimited": "Unlimited active practices",
            "questions": "Up to {0} questions per practice",
            "aiLifetime": "{0} AI practice generations, one-time allowance",
            "aiMonthly": "{0} AI practice generations per month",
            "multipleAttempts": "Multiple attempts",
            "timed": "Timed practices",
            "availability": "End date and availability",
            "progressTracking": "Full progress tracking",
            "attemptHistory": "Detailed attempt history",
            "request": "Ask about this plan",
            "note": "Our team handles Premium and Premium Plus activation. Contact us for the next steps."
        },
        "faq": {
            "eyebrow": "BEFORE YOU BEGIN",
            "title": "Your questions about Athena, answered.",
            "ages": {
                "q": "Who is Athena for?",
                "a": "Athena is for tutors who prepare and assign practices, and students who complete them from their own accounts. As a tutor, you choose the material and adapt the questions to your students’ level and goals."
            },
            "accounts": {
                "q": "Do I need a tutor account?",
                "a": "Yes. A tutor account lets you prepare and assign practices and check results. Each student takes part through their own account."
            },
            "materials": {
                "q": "Can I use my own study material?",
                "a": "Yes. Write your own questions or create a practice with AI from photos or PDFs with readable text. Scanned PDFs and PDFs without readable text are not supported. AI creation is subject to availability and your plan’s limits."
            },
            "plans": {
                "q": "How can I activate a Premium or Premium Plus plan?",
                "a": "Request the plan you want from the plans section of your account. Our team will explain how to pay and activate your plan once payment is verified."
            },
            "payment_options": {
                "q": "How can I pay for my Premium or Premium Plus plan?",
                "a": "You can pay via SINPE to 7275-4063. Once our team verifies your payment, we'll activate the plan you requested."
            },
            "payment_time": {
                "q": "How long does it take to activate my Premium or Premium Plus plan?",
                "a": "Your plan will be activated as soon as our team verifies your payment. Verification may take up to 4 hours, depending on when you make the payment. To help speed up the process, send your payment receipt via WhatsApp to +506 7275-4063."
            },
            "practices": {
                "q": "What is a practice in Athena?",
                "a": "A practice is a set of questions on a topic. The student answers from their own account and receives a score when they submit an attempt. Once they have used all allowed attempts, they can review correct answers and explanations for their mistakes, as long as the practice remains assigned and available."
            },
            "generation": {
                "q": "How does creating a practice with AI work?",
                "a": "Upload photos of your study material or PDFs with readable text, using one format per request. Athena uses that content to draft a practice with AI. Review the questions, answers and explanations, and make any edits before saving. Each plan includes a number of AI generations."
            }
        },
        "closing": {
            "title": "Create your first practice in Athena.",
            "body": "Choose a topic and create a practice to assign to your students."
        },
        "footer": {
            "tagline": "Learning is better together."
        },
        "contact": {
            "eyebrow": "CONTACT",
            "title": "We're here to help.",
            "body": "Have questions about Athena, its plans or getting started with your students? Contact us on WhatsApp or by email.",
            "whatsappCta": "Chat on WhatsApp",
            "message": "Hi, I'd like to learn more about Athena and its plans.",
            "whatsappUnavailable": "WhatsApp support will be available soon.",
            "emailCta": "Send us an email",
            "emailSubject": "Question about Athena",
            "emailUnavailable": "Email support will be available soon.",
            "asideTitle": "Tell us what you need",
            "asideBody": "Tell us how many students you work with and what practices you'd like to create. We'll help you explore Athena's options and choose a plan."
        },
        "missing": {
            "title": "We couldn't find this page.",
            "back": "Back to home"
        },
        "meta": {
            "title": "Athena · Practice platform for tutors and students",
            "description": "Create practices from your study material, assign them to students and review their results. Athena brings preparation and progress tracking into one place.",
            "contactTitle": "Contact · Talk to the Athena team",
            "contactDescription": "Message us on WhatsApp or by email with questions about Athena, its plans and how to use it with your students.",
            "notFoundTitle": "Page not found · Athena",
            "notFoundDescription": "This address does not exist on Athena. Go back to the home page to see the educational practice platform.",
            "imageAlt": "Athena: turn study material into practices for your students.",
            "applicationSubCategory": "Educational practice and assessment",
            "browserRequirements": "Requires a modern web browser with JavaScript enabled"
        }
    },
    "common": {
        "loading": "Loading…",
        "tryAgain": "Try again",
        "clear": "Clear",
        "clearFilters": "Clear filters",
        "clearSearch": "Clear search",
        "review": "Review",
        "correct": "Correct",
        "incorrect": "Incorrect",
        "correctAnswer": "Correct answer",
        "yourAnswer": "Your answer",
        "best": "best",
        "ofTotal": "{0} of {1}",
        "saving": "Saving…",
        "save": "Save changes",
        "cancel": "Cancel",
        "remove": "Remove",
        "moveUp": "Move up",
        "moveDown": "Move down",
        "creating": "Creating…",
        "opening": "Opening…"
    },
    "count": {
        "questionsOne": "1 question",
        "questionsOther": "{0} questions",
        "attemptsOne": "1 attempt",
        "attemptsOther": "{0} attempts",
        "studentsOne": "1 student",
        "studentsOther": "{0} students",
        "problemsOne": "1 problem found in the Markdown",
        "problemsOther": "{0} problems found in the Markdown",
        "markdownProblemsOne": "1 problem stopped this practice from being read",
        "markdownProblemsOther": "{0} problems stopped this practice from being read",
        "questionsReadOne": "1 question read",
        "questionsReadOther": "{0} questions read",
        "imagesOne": "1 image",
        "imagesOther": "{0} images",
        "imagesReadOne": "Text read from 1 image",
        "imagesReadOther": "Text read from {0} images",
        "practicesOne": "1 practice",
        "practicesOther": "{0} practices",
        "availableOne": "1 available",
        "availableOther": "{0} available",
        "matchesOne": "1 match",
        "matchesOther": "{0} matches",
        "documentsOne": "1 PDF",
        "documentsOther": "{0} PDFs",
        "minutesOne": "1 minute",
        "minutesOther": "{0} minutes",
        "secondsOne": "1 second",
        "secondsOther": "{0} seconds",
        "questionsCreatedOne": "1 question created",
        "questionsCreatedOther": "{0} questions created"
    },
    "language": {
        "menuLabel": "Language",
        "es": "Español",
        "en": "English",
        "selected": "Selected"
    },
    "navigation": {
        "skipToContent": "Skip to content",
        "main": "Main",
        "dashboard": "Dashboard",
        "practices": "Practices",
        "students": "Students",
        "home": "Home",
        "progress": "Progress",
        "history": "History",
        "createPractice": "Create practice",
        "createPracticeShort": "Create",
        "signOut": "Sign out",
        "brandHome": "Athena home"
    },
    "notFound": {
        "title": "That page does not exist",
        "back": "Back to the dashboard"
    },
    "appError": {
        "unreachableTitle": "Athena could not be reached",
        "unreachableBody": "Check your internet connection, then try again.",
        "studentUnreachable": "Athena could not be reached. Check your internet connection, then try again.",
        "crashTitle": "This page could not be shown",
        "crashBody": "Something went wrong on our side. Reload the page to try again.",
        "reload": "Reload page",
        "notSetUpTitle": "Your account is not set up yet",
        "notSetUpBody": "You are signed in as {0}. Complete your account setup to continue."
    },
    "auth": {
        "signInTitle": "Sign in or create your account",
        "signInSubtitle": "One way in for everyone. If you are new to Athena, your account is created as you continue — no password needed.",
        "continueWithGoogle": "Continue with Google",
        "continueWithMicrosoft": "Continue with Microsoft",
        "providerDivider": "or",
        "providerFailed": "That could not be started. Try again, or continue with email.",
        "providerCancelled": "That sign-in was cancelled. Nothing has changed.",
        "providerRejected": "We could not sign you in with that account. Try again, or continue with email.",
        "providerNoEmail": "That account did not share an email address, so we cannot use it. Continue with email instead.",
        "emailLabel": "Email address",
        "submit": "Continue with email",
        "submitInvite": "Email me a sign-in code",
        "sending": "Sending…",
        "codeSentTitle": "Check your email",
        "codeSentBody": "If {0} can use Athena, a six-digit code is on its way. It expires in ten minutes.",
        "codeLabel": "Six-digit code",
        "codeHelper": "Type the code from the email. It works once.",
        "codeSubmit": "Continue",
        "verifying": "Continuing…",
        "codeInvalid": "That code is not right, or it has expired. Ask for a new one.",
        "codeRequired": "Type the six-digit code from the email.",
        "resend": "Send another code",
        "useAnotherEmail": "Use a different email address",
        "requestFailed": "That did not go through. Check your connection and try again.",
        "inviteTitle": "You have been invited",
        "inviteSubtitle": "Sign in and your practices will be waiting.",
        "inviteFailed": "That invitation could not be accepted.",
        "inviteRetry": "Try again",
        "emailOnlyHelper": "Sign in with your email address.",
        "emailHelper": "We will email you a six-digit code.",
        "emailRequired": "Enter your email address.",
        "emailInvalid": "Enter a complete email address, like name@example.com.",
        "backToSite": "Back to the Athena website",
        "siteHome": "Athena website"
    },
    "onboarding": {
        "title": "Welcome to Athena",
        "subtitle": "How will you use Athena?",
        "studentTitle": "Student",
        "tutorTitle": "Tutor",
        "studentDescription": "Complete assigned practices and keep track of your results.",
        "tutorDescription": "Create practices, assign them, and follow student progress.",
        "step": "Step {0} of 2",
        "profileTitle": "Complete your profile",
        "firstName": "First name",
        "lastName": "Last name",
        "birthDate": "Date of birth",
        "back": "Back",
        "continue": "Continue",
        "saving": "Saving profile…",
        "completeProgress": "Setup complete",
        "completeTitle": "You’re all set",
        "completeBody": "Your Athena space is ready. Opening your dashboard…",
        "error": "Your profile could not be saved. Try again.",
        "nameError": "Enter a name between 1 and 60 characters.",
        "dateError": "Enter a valid birth date, from 1900 through today."
    },
    "dashboard": {
        "title": "Dashboard",
        "loading": "Loading your dashboard…",
        "error": "Your dashboard could not be loaded. Try again.",
        "greeting": {
            "morning": "Good morning",
            "morningNamed": "Good morning, {0}",
            "afternoon": "Good afternoon",
            "afternoonNamed": "Good afternoon, {0}",
            "evening": "Good evening",
            "eveningNamed": "Good evening, {0}"
        },
        "subtitle": "Here is what is happening with your students.",
        "filtersHeading": "Narrow the dashboard",
        "needsAttention": "Needs attention",
        "recentAttempts": "Recent attempts",
        "noAttemptsTitle": "No recent attempts",
        "noAttemptsForFilter": "This student has not submitted a practice for this filter yet.",
        "firstPracticeTitle": "Create your first practice",
        "firstPracticeDescription": "Turn study material into an interactive practice in minutes.",
        "attention": {
            "emptyTitle": "Everything looks good",
            "emptyDescription": "No students or practices need your attention right now.",
            "viewPractice": "View practice",
            "viewAttempt": "View attempt",
            "viewStudent": "View student",
            "closingSoon": "{0} · closes {1}",
            "inProgress": "{0} · started {1}",
            "notStarted": "{0} · nothing submitted",
            "showingMostUrgent": "Showing the {0} most urgent of {1}."
        },
        "filters": {
            "student": "Student",
            "everyStudent": "Every student",
            "practice": "Practice",
            "everyPractice": "Every practice"
        },
        "feedProgressLabel": "{0}% · {1} of {2} · {3}"
    },
    "practice": {
        "title": "Practice",
        "listTitle": "Practices",
        "loadingList": "Loading practices…",
        "listError": "Your practices could not be loaded. Try again.",
        "loadingOne": "Loading practice…",
        "loadError": "That practice could not be loaded.",
        "notFound": "That practice could not be found.",
        "create": "Create practice",
        "newTitle": "New practice",
        "newSubtitle": "The first heading in your Markdown becomes the practice name.",
        "searchSummary": "Showing practices matching",
        "nothingMatchesTitle": "Nothing matches",
        "nothingMatchesSearch": "No practice has \"{0}\" in its name.",
        "nothingMatchesSearchFiltered": "No practice in this subject has \"{0}\" in its name.",
        "nothingMatchesFilters": "No practices match your filters.",
        "archivedHeading": "Archived",
        "archivedDescription": "Retired from your active list. Nobody can start these, and every past attempt is kept.",
        "setAsideHeading": "Set aside by your plan",
        "setAsideDescription": "Your plan keeps fewer active practices than you have. These hold no slot and take no new assignment or attempt; every version and past attempt is kept. Bring one back when there is room.",
        "setAsideNotice": "Your plan has set this practice aside. It holds no slot, and nobody can be assigned it or start it until you bring it back. Every version and past attempt is kept.",
        "archivedNotice": "This practice is archived. Nobody can start it, and every past attempt is kept. Restore it to put it back in your active list.",
        "noQuestionsYet": "No questions yet",
        "publishedVersion": " · Published version {0}",
        "unpublishedChanges": " · Unpublished changes",
        "publish": "Publish",
        "publishing": "Publishing…",
        "assignedTo": "Assigned to",
        "settingsHeading": "Practice settings",
        "draftQuestions": "Draft questions",
        "questions": "Questions",
        "viewTabsLabel": "How to view the questions",
        "viewWithAnswers": "With answers",
        "viewAsStudent": "As your student sees it",
        "noQuestionsReplace": "This practice has no questions yet. Replace the Markdown below to add some.",
        "replaceHeading": "Replace with new Markdown",
        "replaceDescription": "Saving replaces every question. A published version never changes: this saves a draft you publish when it is ready.",
        "parseAndSaveDraft": "Save draft",
        "versionHistory": "Version history",
        "version": "Version {0}",
        "notPublished": "Not published",
        "draftUpdated": "Draft saved.",
        "published": "Practice published.",
        "created": "Practice created.",
        "unreadable": "The practice could not be read.",
        "pasteToStart": "Paste or drop some Markdown to get started.",
        "chooseSubject": "Choose a subject",
        "parsingAnnouncement": "Creating practice",
        "createTabsLabel": "How to create the practice",
        "filters": {
            "subject": "Subject",
            "everySubject": "Every subject"
        },
        "fields": {
            "subject": "Subject",
            "chooseSubject": "Choose a subject",
            "subjectRequired": "Choose a subject.",
            "subjectHelper": "What this practice is about.",
            "availableUntil": "Available until",
            "availableUntilHelper": "When the practice closes. After that, no attempt can be started or submitted. Leave both empty for no end date.",
            "maxAttempts": "Maximum attempts",
            "maxAttemptsHelper": "Counts submitted attempts only. Empty means no limit.",
            "maxAttemptsInvalid": "Give a whole number of attempts, or leave it empty for no limit.",
            "timed": "Timed practice",
            "timedHelper": "The student gets a fixed amount of time once they start. Off means no time limit.",
            "duration": "Duration",
            "durationHelper": "In minutes, between {0} and {1}.",
            "durationInvalid": "Give a whole number of minutes between {0} and {1}.",
            "timerVersionNote": "A time limit belongs to the version. It can be changed only while a draft is open.",
            "saveSettings": "Save settings",
            "settingsSaved": "Settings saved.",
            "settingsSaveFailed": "Your settings could not be saved. Try again.",
            "availableUntilTime": "Time",
            "availableUntilTimeHelper": "On the hour or the half hour.",
            "availableUntilTimePlaceholder": "Choose a time",
            "availableUntilNeedsDate": "Choose a date for the end time, or clear the time for no end date.",
            "availableUntilNeedsTime": "Choose a time for the end date, or clear the date for no end date.",
            "settingsNotSaved": "Your settings were not saved.",
            "premiumOnly": "Available only with Premium plans.",
            "timedWithoutPlan": "Your plan no longer includes timed practices. Turn off the time limit so your students can start this practice again.",
            "endDateWithoutPlan": "Your plan no longer includes end dates. The one set here still closes this practice. Remove it to keep the practice open.",
            "removeEndDate": "Remove end date"
        },
        "automatic": {
            "tab": "With AI",
            "generate": "Generate practice",
            "readingAnnouncement": "Reading your images",
            "readAnnouncement": "Your images have been read.",
            "failedAnnouncement": "Some images could not be read.",
            "readFailed": "Athena could not read those images. Try again, or write the practice yourself on the Manual tab.",
            "processing": "Generating…",
            "size": "Size",
            "practiceType": "Practice type",
            "aiProvider": "AI Provider",
            "providerGemini": "Gemini",
            "providerOpenAI": "OpenAI",
            "variousTypes": "Various",
            "variousTypesHint": "Various includes multiple choice, matching and short answer.",
            "sizeLabel": {
                "S": "S",
                "M": "M",
                "L": "L",
                "XL": "XL"
            },
            "configHeading": "Practice setup",
            "generating": "Generating your practice…",
            "generatingBody": "Athena is writing questions from your pages. This can take a minute.",
            "generatingAnnouncement": "Generating your practice",
            "generatedAnnouncement": "Your practice was created.",
            "generationFailedAnnouncement": "The practice could not be generated.",
            "generationFailedHeading": "The practice could not be generated",
            "retry": "Try again",
            "retryHint": "Your pages are kept, so trying again does not read them a second time.",
            "sourceHeading": "What should Athena read?",
            "sourceImages": "Photos of the pages",
            "sourcePdfs": "PDF files",
            "sourceLockedImages": "Using photos. Remove them to use PDFs instead.",
            "sourceLockedPdfs": "Using PDFs. Remove them to use photos instead.",
            "needSourceAndSubject": "Choose a subject and add at least one photo or PDF.",
            "readingPdfsAnnouncement": "Reading your PDFs",
            "readPdfsAnnouncement": "Your PDFs have been read.",
            "readSomePdfsAnnouncement": "Your PDFs have been read. {0} could not be used.",
            "pdfsFailedAnnouncement": "None of those PDFs could be read.",
            "rejectedPdf": {
                "type": "{0} is not a PDF.",
                "size": "{0} is larger than {1} MB.",
                "empty": "{0} is empty.",
                "count": "{0} was left out: up to {1} PDFs at a time.",
                "batch": "{0} was left out: the PDFs together would be too large to read at once."
            },
            "sizes": {
                "title": "Image sizes",
                "image": "Image",
                "uploaded": "Uploaded",
                "sent": "Sent to Athena",
                "total": "Total"
            },
            "rejected": {
                "type": "{0} is not a PNG, JPEG or WebP image.",
                "size": "{0} is larger than {1} MB.",
                "count": "{0} was left out: up to {1} images at a time.",
                "unreadable": "{0} could not be opened as an image.",
                "unreadableUnnamed": "This image could not be opened.",
                "duplicate": "{0} is already in the list."
            },
            "questionTypes": "Question types",
            "questionTypesHint": "Select the question types to include.",
            "questionTypesFreeHint": "Free includes multiple choice. Other types are available with Premium.",
            "questionTypesRequired": "Select at least one question type.",
            "questionTypesInfo": "About question types on Free"
        },
        "manual": {
            "tab": "Manual"
        },
        "archive": {
            "restore": "Restore practice",
            "restoring": "Restoring…",
            "archive": "Archive practice",
            "archiving": "Archiving…",
            "confirmTitle": "Archive {0}?",
            "keep": "Keep it active",
            "consequenceNone": "No student has it assigned. Every attempt and score is kept, and you can restore it at any time.",
            "consequenceOne": "1 student can no longer start it. Every attempt and score is kept, and you can restore it at any time.",
            "consequenceOther": "{0} students can no longer start it. Every attempt and score is kept, and you can restore it at any time.",
            "archiveFailed": "The practice was not archived.",
            "restoreFailed": "The practice was not restored.",
            "archived": "Practice archived.",
            "restored": "Practice restored."
        },
        "assign": {
            "addStudentFirst": "Add a student before assigning this practice to anyone.",
            "publishFirst": "Publish this practice before assigning it.",
            "assigned": "Assigned to {0}",
            "removed": "Removed from {0}",
            "removeTitle": "Remove this practice from {0}?",
            "removeTitleFallback": "Remove this practice from this student?",
            "removeConsequence": "{0} can no longer open this practice. Their scores stay in their history, and you can assign it again at any time.",
            "removeConsequenceFallback": "They can no longer open this practice. Their scores stay in their history, and you can assign it again at any time.",
            "removeFrom": "Remove from {0}",
            "removeFallback": "Remove practice",
            "removing": "Removing…",
            "keep": "Keep assigned",
            "assignFailed": "{0} was not assigned this practice.",
            "removeFailed": "This practice was not removed from {0}."
        },
        "questionList": {
            "correctOrder": "Correct order",
            "accepted": "Accepted: ",
            "correct": "Correct"
        },
        "questionEdit": {
            "edit": "Edit question {0}",
            "delete": "Delete question {0}",
            "deleteTitle": "Delete question {0}?",
            "deleteDescription": "This removes the question from this draft. Published versions and past attempts are unchanged.",
            "deleteConfirm": "Delete question",
            "keep": "Keep question",
            "deleted": "Question deleted.",
            "saved": "Question saved.",
            "failed": "The question could not be saved.",
            "deleteFailed": "The question could not be deleted.",
            "prompt": "Question",
            "explanation": "Explanation",
            "correctAnswer": "Correct answer",
            "option": "Option {0}",
            "addOption": "Add option",
            "acceptedAnswer": "Accepted answer {0}",
            "addAnswer": "Add accepted answer",
            "correctOrder": "Correct order",
            "orderItem": "Position {0}",
            "leftItem": "Left item {0}",
            "rightItem": "Matching item {0}",
            "addPair": "Add pair"
        },
        "newVersion": {
            "action": "Create new version",
            "creating": "Creating version…",
            "description": "Copies the published questions into a new editable draft. Assignments and attempts stay with their existing history.",
            "created": "New draft version created.",
            "failed": "The new version could not be created.",
            "publishBeforeRestore": "Publish the new draft before restoring this practice."
        },
        "preview": {
            "questionProgress": "Question {0} of {1}",
            "yourAnswer": "Your answer",
            "typeYourAnswer": "Type your answer"
        },
        "chatgpt": {
            "title": "Create a practice with ChatGPT",
            "description": "Copy the prompt below and paste it into ChatGPT. Paste the result into the text editor.",
            "show": "Show the prompt",
            "promptLabel": "The ChatGPT prompt",
            "copy": "Copy prompt",
            "copied": "Prompt copied"
        },
        "editor": {
            "label": "Markdown source",
            "placeholder": "# Fractions\n\n## Question 1\nWhat is 1/2 + 1/4?\n\n- A. 3/4\n- B. 2/6\n\n**Answer:** A\n\n## Question 2\nPut these steps in order.\n\n- A. Add the numerators\n- B. Find a common denominator\n- C. Simplify\n\n**Type:** Association\n\n**Answer:** B, A, C\n\n## Question 3\nMatch each part with what it means.\n\n**Type:** Matching\n\n- Numerator -> The number above the line\n- Denominator -> The number below the line"
        },
        "meta": {
            "active": "Active",
            "archived": "Archived",
            "archivedOn": "Archived {0}",
            "noEndDate": "No end date",
            "availableUntil": "Available until {0}",
            "unlimitedAttempts": "Unlimited attempts",
            "attemptsEachOne": "1 attempt each",
            "attemptsEachOther": "{0} attempts each",
            "notPublishedYet": "Not published yet",
            "notAssigned": "Not assigned",
            "assignedToOne": "Assigned to 1 student",
            "assignedToOther": "Assigned to {0} students",
            "updated": "Updated {0}",
            "timed": "Timed: {0}",
            "untimed": "No time limit"
        },
        "unpublishedChangesNote": "Not live for students until you publish.",
        "publishFailed": "The practice was not published.",
        "draftFailed": "Your draft was not saved. Your Markdown is still here.",
        "createUnconfirmed": "Athena could not confirm the practice was created. Check your practices before creating it again.",
        "preferences": {
            "navLabel": "Configuration",
            "title": "Practice settings",
            "subjectsTitle": "Subjects for new practices",
            "description": "Choose the categories and subjects shown when creating a practice. Primary and Secondary are selected initially. These preferences apply only to your account in this browser.",
            "search": "Search subjects",
            "all": "Select all",
            "save": "Save preferences",
            "saved": "Preferences saved.",
            "saveError": "Your browser could not save these preferences. Allow local storage and try again.",
            "required": "Select at least one subject.",
            "noResults": "No matching subjects. Clear your search or try another name.",
            "loadError": "The subject catalog could not be loaded.",
            "selectionSummary": "Selected: {0} of {1}",
            "unsavedTitle": "Leave without saving preferences?",
            "unsavedBody": "Your subject selection has not been saved. Leaving discards these changes.",
            "keepEditing": "Keep editing",
            "discard": "Leave without saving"
        }
    },
    "questionType": {
        "MULTIPLE_CHOICE": "Multiple choice",
        "TRUE_FALSE": "True or false",
        "SHORT_ANSWER": "Short answer",
        "ASSOCIATION": "Put in order",
        "MATCHING": "Matching"
    },
    "student": {
        "backToStudents": "Back to students",
        "title": "Student",
        "listTitle": "Students",
        "listError": "That list could not be loaded. Try again.",
        "loadError": "That student could not be loaded.",
        "addHeading": "Add a student",
        "yourStudents": "Your students",
        "noneYet": "No connected students yet. Send a request above to get started.",
        "signedInAndReady": "Signed in and ready",
        "noAccountYet": "No account yet",
        "signedIn": "Signed in",
        "lookingForScores": "Looking for scores?",
        "openAPractice": "Open a practice",
        "byPractice": "By practice",
        "noPracticeFinishedTitle": "{0} has not finished a practice yet",
        "noPracticeFinishedDescription": "Assign a practice, and their attempts will appear here grouped by practice.",
        "invite": {
            "pendingConnection": "Student connection pending"
        },
        "history": {
            "scoreOnly": "Score only",
            "summary": "Average {0}% · Best {1}% · {2}",
            "correctOf": "{0} of {1}"
        },
        "age": "{0} years old",
        "noEmail": "No email on file",
        "noBirthDate": "No date of birth on file",
        "setAsideDetail": "Set aside. No new practices can be assigned; their work and scores are untouched."
    },
    "attempt": {
        "reviewNotIncluded": "Earlier attempts, answer by answer, are part of the paid plans. The score is kept on the student’s page.",
        "title": "Attempt",
        "loading": "Loading attempt…",
        "loadError": "That attempt could not be loaded.",
        "runnerLoadError": "This practice could not be loaded.",
        "runnerNotFound": "This practice could not be found.",
        "noQuestions": "This practice has no questions yet.",
        "questionProgress": "Question {0} of {1}",
        "yourAnswer": "Your answer",
        "back": "Back",
        "next": "Next",
        "submit": "Submit",
        "checking": "Submitting…",
        "saveAndClose": "Save & close",
        "stopTitle": "Stop for now?",
        "stopConsequence": "Your answers and the question you are on are kept, and you can pick this practice up where you left off. Nothing is marked until you submit.",
        "keepGoing": "Keep going",
        "submitted": "Submitted. You scored {0} out of {1}.",
        "submitFailed": "That could not be submitted. Try again.",
        "saveFailed": "That could not be saved. Try again.",
        "autosaveFailed": "Your latest answer is not saved yet.",
        "autosaveRetrying": "Athena will keep trying on its own. Check your internet connection.",
        "autosaveRecovered": "Your answers are saved.",
        "submitNotSaved": "Your practice has not been submitted yet, because your answers could not be saved.",
        "leaveUnsavedTitle": "Leave before your answer is saved?",
        "leaveUnsavedConsequence": "Your latest answer is not saved yet. If you leave now, it may be lost.",
        "leaveAnyway": "Leave anyway",
        "unansweredOne": "1 question is still unanswered",
        "unansweredOther": "{0} questions are still unanswered",
        "unansweredConsequence": "Submitting finishes this attempt, and it cannot be undone. You can go back and finish them first, or submit it as it is.",
        "finishAnswering": "Finish answering",
        "submitAnyway": "Submit anyway",
        "attemptNumber": "Attempt {0}",
        "tryAgain": "Try again",
        "backToPractices": "Back to my practices",
        "yourAttempts": "Your attempts",
        "firstAttempt": "This is your first attempt.",
        "review": {
            "title": "What happened, question by question",
            "loading": "Loading your results…",
            "unavailable": "Your score is saved. The question-by-question answers are not available for this practice.",
            "allRight": "Every question was right.",
            "toLookAtOne": "1 question to look at.",
            "toLookAtOther": "{0} questions to look at.",
            "correct": "✓ Correct",
            "notRight": "✕ Incorrect",
            "youPut": "You put",
            "theAnswer": "The answer",
            "youPutLabel": "You put: ",
            "theAnswerLabel": "The answer: ",
            "nothing": "nothing"
        },
        "tutorReview": {
            "credit": "{0} of {1}",
            "studentPut": "{0} put",
            "matches": "Matches",
            "studentsAnswer": "{0}'s answer",
            "correctOrder": "Correct order",
            "choseThis": "{0} chose this",
            "correctAnswer": "Correct answer",
            "theirAnswer": "Their answer: ",
            "leftBlank": "Left blank",
            "accepted": "Accepted: "
        },
        "timer": {
            "remaining": "Time remaining: {0}",
            "expired": "Time's up",
            "expiredAnnouncement": "Time is up. Your practice has been submitted.",
            "warningAnnouncement": "{0} left.",
            "criticalAnnouncement": "Only {0} left."
        },
        "stopTimedTitle": "Leave this practice?",
        "stopTimedConsequence": "Your answers are saved, but the clock keeps running while you are away. When the time runs out, the practice is submitted as it stands.",
        "saveAndLeave": "Save and leave",
        "expiredNotice": "Time ran out. This practice was submitted with the answers you had saved.",
        "savedAndClosed": "Your progress is saved."
    },
    "learn": {
        "title": "Your practices",
        "loadError": "Your practices could not be loaded.",
        "startFailed": "That practice could not be opened.",
        "emptyTitle": "Nothing to practice yet",
        "emptyDescription": "When someone assigns you a practice, it will show up here.",
        "continueHeading": "Continue practice",
        "availableHeading": "Available practices",
        "nothingNew": "Nothing new to start right now. Well done.",
        "nothingToStart": "Nothing can be started right now. Each practice below says why.",
        "card": {
            "attemptsLeft": "Attempts left: {0} of {1}",
            "until": "Until {0}",
            "start": "Start",
            "startNamed": "Start {0}",
            "tryAgain": "Try again",
            "tryAgainNamed": "Try again: {0}",
            "notAvailable": "Not available right now",
            "blockedArchived": "Archived by your tutor",
            "blockedClosed": "No longer available",
            "blockedMaxAttempts": "You have used all your attempts",
            "blockedNotPublished": "Not available yet",
            "timed": "Timed · {0}"
        },
        "continue": {
            "readyToResume": "Ready to pick up where you left off",
            "questionProgress": "Question {0} of {1}",
            "resume": "Continue practice"
        },
        "timed": {
            "dialogTitle": "This practice is timed",
            "dialogDuration": "You will have {0} from the moment you start.",
            "dialogRules": "The clock cannot be paused. Closing the practice, or your browser, does not stop it. When the time runs out, the practice is submitted with the answers you have saved.",
            "dialogStart": "Start practice",
            "dialogCancel": "Not yet"
        },
        "group": {
            "noneAvailable": "nothing to start now"
        }
    },
    "history": {
        "title": "Your history",
        "loadError": "Your history could not be loaded. Try again.",
        "emptyTitle": "Nothing finished yet",
        "emptyDescription": "When you submit a practice, it stays here with your score — even after it leaves your list.",
        "intro": "Every practice you have finished. Your scores stay here for good.",
        "detail": "{0} · Submitted {1}",
        "seeTheAnswers": "See the answers",
        "scoreOnly": "Score only",
        "blockedUnassigned": "No longer on your list",
        "blockedArchived": "Archived by your tutor",
        "blockedClosed": "No longer available",
        "blockedAttemptsRemaining": "You still have an attempt left",
        "blockedNotSubmitted": "Not submitted yet"
    },
    "progress": {
        "withheldNote": "Some best scores are not shown because they are part of a paid tutor plan. Every score you got is kept.",
        "title": "Your progress",
        "intro": "Each practice you have finished, and how it went each time.",
        "loadError": "Your progress could not be loaded.",
        "emptyTitle": "Nothing to show yet",
        "emptyDescription": "Your progress will appear here after you finish a practice.",
        "emptyAction": "Go to your practices",
        "practice": {
            "latest": "Latest",
            "best": "Best",
            "evolution": "Progress",
            "lastOn": "Last attempt {0}",
            "sequenceLabel": "Your scores on {0}, first to latest",
            "allAttempts": "All attempts",
            "seeTheAnswersNamed": "See the answers to {0}"
        }
    },
    "admin": {
        "includedFeatures": "Included in this plan",
        "noPaidFeatures": "No paid features: one attempt, no time limit or end date, and scores without averages or earlier answers",
        "badge": "Administration",
        "navLabel": "Administration",
        "navUsers": "Accounts",
        "navRequests": "Requests",
        "noAccessTitle": "This area is for administrators",
        "noAccessBody": "Sign in to Athena with an administrator account, then come back.",
        "signOutFailedTitle": "You may still be signed in",
        "signOutFailedBody": "Athena could not confirm that your session ended. Check your connection and sign out again, or close this browser before someone else uses it.",
        "openAthena": "Open Athena",
        "loadError": "That could not be loaded.",
        "usersTitle": "Accounts",
        "searchLabel": "Search by name or email",
        "noUsers": "No accounts match these filters.",
        "roleTutor": "Tutor",
        "roleStudent": "Student",
        "roleAdmin": "Administrator",
        "accountCreated": "Account created {0}",
        "noSubscriptionTitle": "No tutor profile",
        "noSubscriptionBody": "Subscriptions belong to tutor accounts. A student needs none — their access comes from the tutor who assigned the practice.",
        "subscriptionTitle": "Subscription",
        "storedPlan": "Stored",
        "enforcedPlan": "Limits applied",
        "enforcementPending": "Not yet applied to their resources",
        "since": "Since {0}",
        "lapsedTitle": "Paid access has ended",
        "lapsedBody": "Recorded as paid up to {0}. The account is on the Free plan.",
        "period": "Current month",
        "accessEnds": "Paid up to",
        "scheduled": "Scheduled change",
        "students": "Students",
        "practices": "Active practices",
        "blockedTitle": "Practices no student can start",
        "blockedTimed": "timed",
        "manageTitle": "Manage plan",
        "manageBody": "Athena takes no payment. These record an arrangement made elsewhere, and every one of them is written to the audit log with your name and your reason.",
        "planLabel": "Plan",
        "planPlaceholder": "Choose a plan",
        "accessEndsLabel": "Date",
        "accessEndsHelper": "Paid up to, for assigning; the effective date, for scheduling.",
        "assignPlan": "Assign now",
        "scheduleChange": "Schedule for later",
        "endAccess": "End paid access",
        "endAccessTitle": "End paid access on {0}?",
        "endAccessBody": "From {0}, this account moves to the Free plan, whose limits are {1} for students, {2} for active practices and {3} for questions per practice, with no timed practices. Whatever does not fit is set aside, not deleted, and comes back if a paid plan is assigned again.",
        "keepPaidAccess": "Keep paid access",
        "aiTitle": "AI usage",
        "aiBody": "Corrections are new ledger rows, never edits: what the tutor actually spent stays as it is.",
        "aiAdjustmentTitle": "New adjustment",
        "aiHistoryEmpty": "No AI usage recorded yet.",
        "adjustmentLabel": "Adjustment",
        "adjustmentHelper": "Negative returns credits, positive takes them back.",
        "adjust": "Record adjustment",
        "relationshipsTitle": "Students",
        "relationshipsEmpty": "No connected students yet.",
        "accountSections": "Account sections",
        "suspended": "Set aside",
        "enabled": "Active",
        "requestsTitle": "Upgrade requests",
        "requestsBody": "A tutor has asked to move to a paid plan. Approving answers the request and applies the plan; declining answers it and changes nothing.",
        "requestsEmpty": "No requests waiting for review.",
        "decisionNote": "Note to record",
        "approve": "Approve and apply",
        "decline": "Decline",
        "auditTitle": "Audit log",
        "auditEmpty": "No audit history yet.",
        "auditLoadMore": "Load more",
        "auditLoadingMore": "Loading more…",
        "auditDetails": "View raw changes",
        "auditBefore": "Before",
        "auditAfter": "After",
        "auditDeletedActor": "A deleted administrator",
        "auditActionGeneric": "Administrative change",
        "auditActionUserCreated": "User created",
        "auditActionUserUpdated": "User updated",
        "auditActionUserFeatureFlagUpdated": "User feature flag updated",
        "auditActionUserFeatureFlagsUpdated": "User feature flags updated",
        "auditFieldFeatureFlag": "Feature flag",
        "auditFieldEnabled": "Enabled",
        "auditActionUserDeleted": "User deleted",
        "auditActionSubjectCreated": "Subject created",
        "auditActionSubjectUpdated": "Subject updated",
        "auditActionSubjectDeleted": "Subject deleted",
        "auditActionSubscriptionChanged": "Subscription changed",
        "auditActionUsageChanged": "AI usage changed",
        "planNotChanged": "The plan was not changed.",
        "adjustmentUnconfirmed": "Athena could not confirm the adjustment was recorded. Check the history below before adjusting again.",
        "decisionNotMade": "The request was not answered.",
        "requestApproved": "Request from {0} approved.",
        "requestDeclined": "Request from {0} declined.",
        "titleSuffix": "Athena Administration",
        "accountPageTitle": "Account",
        "notFoundBack": "Back to accounts",
        "noAccounts": "No accounts yet.",
        "accountsCountOne": "1 account",
        "accountsCountOther": "{0} accounts",
        "allProfiles": "All profiles",
        "allStatuses": "All statuses",
        "columnAccount": "Account",
        "columnProfiles": "Profiles",
        "columnStatus": "Status",
        "columnCreated": "Created",
        "noProfile": "No profile",
        "statusActive": "Active",
        "statusDisabled": "Disabled",
        "statusInvited": "Invitation pending",
        "emailUnverified": "Email not verified",
        "emailVerified": "Email verified",
        "pagination": "Pages",
        "listLoadError": "The list could not be loaded. Your search and filters are kept.",
        "sectionAccess": "Access",
        "accessActiveBody": "This account can sign in.",
        "accessDisabledBody": "This account is disabled and cannot sign in. Everything it owns is kept.",
        "technicalDetails": "Technical details",
        "techUserId": "User ID",
        "techTutorId": "Tutor ID",
        "techStudentId": "Student ID",
        "techPlanCodes": "Plan codes (stored · in force · limits applied)",
        "techEntryId": "Entry ID",
        "techAction": "Action code",
        "techRecord": "Record",
        "planInForce": "Plan in force",
        "capacityValue": "{0} of {1}",
        "capacityOver": "{0} over the limit",
        "aiCredits": "AI credits this month",
        "aiCreditsValue": "{0} used of {1}",
        "aiCreditsHeldOne": "1 held for a request in progress",
        "aiCreditsHeldOther": "{0} held for requests in progress",
        "scheduledValue": "{0} from {1}",
        "scheduledByAdmin": "Scheduled by an administrator. The tutor cannot cancel it.",
        "scheduledByTutor": "Scheduled by the tutor, who can cancel it.",
        "noScheduledChange": "None",
        "noEndDate": "No end date",
        "planActionsRoutine": "Assigning or scheduling a plan is recorded with your reason and can be changed again at any time.",
        "endAccessHeading": "End paid access",
        "endAccessHelp": "From the date above, the account moves to the Free plan. Whatever does not fit is set aside, not deleted.",
        "aiHistoryCaption": "AI usage history",
        "columnWhen": "When",
        "columnEvent": "Event",
        "columnCredits": "Credits",
        "columnNote": "Note",
        "usageKindGeneration": "AI practice generation",
        "usageKindAdjustment": "Manual adjustment",
        "usageKindExtraction": "AI image reading",
        "usageStatusConsumed": "Used",
        "usageStatusReserved": "Held",
        "usageStatusReleased": "Released, not charged",
        "usageStatusFailedFree": "Failed, not charged",
        "usageStatusFailedCharged": "Failed, charged (free failures used up)",
        "creditsOne": "1 credit",
        "creditsOther": "{0} credits",
        "creditsReturnedOne": "1 credit returned",
        "creditsReturnedOther": "{0} credits returned",
        "relationshipsCaption": "Connected students",
        "columnStudent": "Student",
        "columnEmail": "Email",
        "columnConnected": "Connected",
        "suspendedByPlan": "Set aside by a plan limit",
        "suspendedByTutor": "Set aside by the tutor",
        "unclaimed": "Invitation not accepted",
        "requestedPlan": "Requested plan",
        "requestedOn": "Requested {0}",
        "tutorMessage": "Message from the tutor",
        "decisionNoteHelper": "Required to approve or decline. It is recorded in the audit log.",
        "findAccount": "Open in accounts",
        "requestsCountOne": "1 request waiting",
        "requestsCountOther": "{0} requests waiting",
        "subjectsCountOne": "1 subject",
        "subjectsCountOther": "{0} subjects",
        "subjectsCaption": "Subjects",
        "searchSubjects": "Search by code or name",
        "noSubjects": "No subjects yet.",
        "noMatchingSubjects": "No subjects match these filters.",
        "columnSubject": "Subject",
        "columnPractices": "Practices",
        "subjectDetails": "Subject details",
        "subjectAvailability": "Availability",
        "subjectAvailable": "Available for new practices",
        "subjectStatusActive": "Active",
        "subjectStatusInactive": "Inactive",
        "auditActorTutor": "The tutor, from their plan screen",
        "auditActorAutomatic": "Athena, automatically",
        "auditReason": "Reason",
        "auditNoFields": "No field-level changes were recorded.",
        "auditActionUserDisabled": "Account disabled",
        "auditActionUserReactivated": "Account reactivated",
        "auditActionPlanAssigned": "Plan assigned",
        "auditActionChangeScheduled": "Plan change scheduled",
        "auditActionAccessEnded": "Paid access ended",
        "auditActionRequestApproved": "Upgrade request approved",
        "auditActionRequestDeclined": "Upgrade request declined",
        "auditActionLimitsEnforced": "Plan limits applied",
        "auditActionDowngradeScheduled": "Downgrade scheduled",
        "auditActionDowngradeCancelled": "Scheduled downgrade cancelled",
        "auditFieldPlan": "Plan",
        "auditFieldPlanInForce": "Plan in force",
        "auditFieldAccessEnds": "Paid up to",
        "auditFieldAnchor": "Monthly anniversary",
        "auditFieldScheduledPlan": "Scheduled plan",
        "auditFieldScheduledAt": "Takes effect",
        "auditFieldAccess": "Access",
        "auditFieldTutor": "Tutor profile",
        "auditFieldStudent": "Student profile",
        "auditFieldAdmin": "Administrator",
        "auditFieldLanguage": "Preferred language",
        "auditFieldProfiles": "Profiles",
        "auditFieldEmail": "Email",
        "auditFieldCode": "Code",
        "auditFieldSubjectStatus": "Status",
        "auditFieldSpanishName": "Spanish name",
        "auditFieldEnglishName": "English name",
        "auditFieldName": "Name",
        "auditFieldProfileNames": "Profile names",
        "auditFieldCreditsUsed": "AI credits used",
        "auditFieldCreditsLeft": "AI credits left",
        "auditFieldAdjustment": "Adjustment",
        "auditFieldRequestedPlan": "Requested plan",
        "auditFieldRequestStatus": "Request",
        "auditFieldStudentsSetAside": "Students set aside",
        "auditFieldPracticesSetAside": "Practices set aside",
        "auditFieldInvitationsRevoked": "Invitations revoked",
        "auditFieldRecord": "Record",
        "auditValueYes": "Yes",
        "auditValueNo": "No",
        "auditValueChanged": "Changed",
        "auditValueDeleted": "Deleted",
        "auditValueVerified": "Verified",
        "auditValueUnverified": "Not verified",
        "auditValueDeclined": "Declined",
        "auditValueApproved": "Approved",
        "auditValuePending": "Pending",
        "auditValueWithdrawn": "Withdrawn",
        "auditValueNone": "None",
        "auditActorLabel": "Changed by",
        "studentLimitTitle": "Student limit",
        "studentLimitBody": "Set a custom student limit for this tutor’s paid plan. Leave the field empty to use the plan default ({0}). Free always uses its own limit.",
        "studentLimitLabel": "Custom student limit",
        "studentLimitSave": "Save student limit",
        "studentLimitInvalid": "Enter a positive whole number, or leave empty to use the plan default.",
        "studentLimitUnconfirmed": "Student limit change not confirmed",
        "studentLimitFree": "Custom student limits apply only while a paid plan is active."
    },
    "subscription": {
        "upgradeInterest": "Request {0}",
        "upgradeConfirmTitle": "Request access to {0}?",
        "upgradeConfirmBody": "You will send a request for access to {0}. Your current plan will remain unchanged until an administrator approves and activates your access.",
        "upgradeCancel": "Not now",
        "requestPending": "Request pending",
        "title": "Plan and usage",
        "navLabel": "Plan",
        "loadError": "Your plan could not be loaded.",
        "currentPlan": "Current plan",
        "perMonth": "{0} a month",
        "free": "Free",
        "planName": {
            "FREE": "Free",
            "PREMIUM": "Premium",
            "PREMIUM_PLUS": "Premium Plus"
        },
        "since": "On this plan since {0}",
        "periodEnds": "This month runs to {0}",
        "accessEnds": "Paid access is recorded up to {0}",
        "lapsedTitle": "Paid access has ended",
        "lapsedBody": "This account is on the Free plan. Request an upgrade to get the paid plan’s limits back.",
        "usageHeading": "Usage and limits",
        "planLimitsHeading": "What this plan allows",
        "questionsUpTo": "Up to {0} questions per practice",
        "timedIncluded": "Timed practices included",
        "timedNotIncluded": "No timed practices on this plan",
        "atLimitStudents": "You have reached this plan’s student limit.",
        "atLimitPractices": "You have reached this plan’s active-practice limit.",
        "unlimited": "unlimited",
        "unlimitedUsage": "{0} used, unlimited",
        "unlimitedCapacity": "No active practice limit",
        "atLimitAskLarger": "Request a larger plan below to add more.",
        "studentsLabel": "Connected students",
        "practicesLabel": "Active practices",
        "aiLabel": "AI generations",
        "ofLimit": "{0} of {1}",
        "remainingCount": "{0} left",
        "reservedNote": "{0} in progress",
        "invitationsReservedOne": "1 held by an invitation",
        "invitationsReservedOther": "{0} held by invitations",
        "aiResets": "Resets {0}",
        "aiIntroductory": "Introductory, and they do not reset",
        "aiNoneLeft": "None left",
        "overLimitTitle": "You are over your plan",
        "overLimitStudents": "You have {0} students and this plan allows {1}.",
        "overLimitPractices": "You have {0} active practices and this plan allows {1}.",
        "overLimitBody": "Nothing has been taken away. You cannot add more until you free some room or move to a larger plan.",
        "blockedHeading": "Practices students cannot open",
        "blockedBody": "Nothing here has been changed. Open a practice to fix it: shorten a long one and publish it, or turn off its time limit. Moving to a larger plan also opens them.",
        "blockedAction": "Open practice",
        "blockedTooLong": "{0} questions, and this plan allows {1}",
        "blockedTimed": "Timed, and timed practices are part of the paid plans",
        "blockedState": "Cannot open",
        "resourceName": "Name",
        "resourceReason": "Reason",
        "resourceState": "Status",
        "resourceAction": "Action",
        "currentBadge": "Your plan",
        "upgradeMessageLabel": "Anything you want to add",
        "upgradeMessagePlaceholder": "Optional",
        "upgradeSubmit": "Send request",
        "upgradeSubmitting": "Sending…",
        "upgradeSent": "Request sent for {0}.",
        "pendingHeading": "Request waiting for an answer",
        "pendingBody": "You asked for {0} on {1}. Nothing has changed yet — you are still on {2}.",
        "pendingWithdraw": "Withdraw request",
        "declinedHeading": "Your last request was declined",
        "declinedBody": "You asked for {0} on {1}.",
        "downgradeHeading": "Downgrade to a smaller plan",
        "downgradeBody": "The change takes effect at the end of the month you have paid for, on {0}. Nothing is refunded, because Athena does not take payment in the app.",
        "downgradeSubmit": "Schedule downgrade to {0}",
        "scheduledHeading": "Downgrade scheduled",
        "scheduledBody": "This account moves to {0} on {1}.",
        "scheduledCancel": "Cancel scheduled downgrade",
        "selectionHeading": "Choose what stays active",
        "selectionBody": "On {0} this plan holds {1} students and {2} practices. Pick what to keep; anything you do not pick is put aside, oldest first. Nothing is deleted, and you can bring it back later.",
        "selectionStudents": "Students to keep",
        "selectionPractices": "Practices to keep",
        "selectionSave": "Save choice",
        "selectionSaved": "Your choice has been saved.",
        "selectionTooMany": "Pick at most {0}.",
        "suspendedStudentsHeading": "Students set aside",
        "suspendedStudentsBody": "Their work and their scores are untouched. Bring one back when there is room.",
        "suspendedPracticesHeading": "Practices set aside",
        "suspendedPracticesBody": "Every version and every attempt is untouched. Bring one back when there is room.",
        "suspendedBySubscription": "Set aside by a plan change",
        "suspendedByTutor": "You set this aside",
        "suspendedState": "Set aside",
        "restore": "Bring back",
        "bringBackOnPlan": "Bring back on your plan",
        "invitationsHeading": "Invitations holding a place",
        "invitationsBody": "A pending invitation keeps a student slot until it is accepted or expires.",
        "invitationExpires": "Expires {0}",
        "invitationRevoke": "Withdraw",
        "invitationState": "Pending",
        "aiExhaustedHint": "You have no AI generations left. The Manual tab still works.",
        "aiRemainingHintOne": "1 AI generation left.",
        "aiRemainingHintOther": "{0} AI generations left.",
        "changeNotMade": "That change to your plan was not made.",
        "selectionNotSaved": "Your choice was not saved."
    },
    "badge": {
        "published": "Published",
        "draft": "Draft",
        "assigned": "Assigned",
        "error": "Errors",
        "archived": "Archived",
        "setAside": "Set aside",
        "closing": "Closing soon",
        "lowScore": "Low score",
        "inProgress": "In progress",
        "notStarted": "Not started"
    },
    "ui": {
        "search": {
            "label": "Search",
            "placeholder": "Search practices"
        },
        "attemptSummary": {
            "empty": "No attempts yet."
        },
        "score": {
            "ringLabel": "{0} of {1} correct",
            "value": "{0} / {1} correct"
        },
        "matching": {
            "notMatched": "Not matched",
            "leftUnmatched": "Left unmatched",
            "termsHeading": "Terms",
            "definitionsHeading": "Definitions",
            "chooseFor": "Match for {0}",
            "instructions": "Choose a match for each term. On a wide screen you can also drag a definition onto one.",
            "clear": "Clear the match for {0}",
            "matchedWith": "Matched with {0}",
            "announceMatched": "{0} matched with {1}.",
            "announceUnmatched": "{0} unmatched."
        },
        "ordering": {
            "dropHere": "Drop an option here",
            "answerHeading": "Your answer",
            "moveUp": "Move {0} up",
            "moveDown": "Move {0} down",
            "availableHeading": "Available options",
            "instructions": "Drag each option into place, or use the buttons on it to move it.",
            "remove": "Remove {0} from your answer",
            "add": "Add {0} to your answer",
            "announceMoved": "{0} moved to position {1}.",
            "announceReturned": "{0} moved back to the available options.",
            "allPlaced": "Every option is in your answer.",
            "leftBlank": "Left blank"
        },
        "markdown": {
            "parsing": "Reading your practice…",
            "document": "Document",
            "line": "Line {0}",
            "fixInEditor": "Fix in editor",
            "stillHere": "Your Markdown is still here. Fix the lines above and try again.",
            "dropTitle": "Drop a .md file, or paste Markdown",
            "browse": "Browse files"
        },
        "images": {
            "dropTitle": "Drag images here",
            "browse": "Choose images",
            "accepted": "PNG, JPEG or WebP, up to {0} MB each. {1} images at a time.",
            "hint": "Add photos or screenshots of the questions. Athena prepares them in your browser, then reads each page into text. The images are used for the reading and are never stored.",
            "hintLabel": "About the images",
            "selectedHeading": "Selected images",
            "preview": "Preview of {0}",
            "removeAction": "Remove",
            "remove": "Remove {0}",
            "clearAll": "Remove all",
            "rejectedHeading": "Some files were not added"
        },
        "documents": {
            "dropTitle": "Drop PDFs here",
            "browse": "Choose PDFs",
            "accepted": "PDF files, up to {0} MB each, {1} at a time.",
            "hint": "Athena reads the text in a PDF. Scanned pages, photos and diagrams are skipped.",
            "hintLabel": "About the PDFs",
            "rejectedHeading": "Some files were not added",
            "selectedHeading": "Your PDFs",
            "listLabel": "PDFs to read, in the order they will be read",
            "clear": "Remove all",
            "remove": "Remove",
            "removeNamed": "Remove {0}",
            "pending": "Waiting",
            "reading": "Reading",
            "read": "Read",
            "failed": "Could not be read"
        },
        "extraction": {
            "imageOf": "Image {0} of {1}",
            "pending": "Waiting",
            "compressing": "Preparing",
            "extracting": "Reading",
            "extracted": "Read",
            "failed": "Could not be read",
            "retry": "Try again",
            "retryImage": "Try again: {0}",
            "startingLabel": "Preparing your images…",
            "contentLabel": "The content read from your images",
            "show": "Show the content",
            "noText": "No text was found in those images. Clearer photos usually read better.",
            "failedHeading": "The pages could not be read",
            "failedBody": "Try again, or remove a photo that came out badly and read the rest.",
            "readingLabel": "Reading your pages…"
        },
        "field": {
            "optional": "Optional"
        },
        "failure": {
            "connection": "Athena could not be reached. Check your internet connection, then try again.",
            "signedOut": "Your session has ended. Sign in again, then try again.",
            "forbidden": "Your account is not allowed to do that.",
            "notFound": "That is no longer available. It may have been removed.",
            "invalid": "That could not be accepted. Check what you entered, then try again.",
            "unexpected": "Something went wrong on our side. Try again in a moment.",
            "retrying": "Trying again…"
        },
        "toast": {
            "dismiss": "Dismiss"
        },
        "practiceCard": {
            "open": "Open"
        },
        "changeList": {
            "from": "from",
            "to": "to"
        },
        "select": {
            "search": "Search subjects",
            "noResults": "No matching subjects."
        }
    },
    "email": {
        "signInCode": {
            "subject": "Your Athena sign-in code",
            "preview": "Your Athena sign-in code",
            "heading": "Sign in to Athena",
            "body": "Type this code into the page that asked for it. It works once and expires in {0} minutes.",
            "footer": "If you did not ask to sign in, ignore this email. Nothing happens until the code is used."
        },
        "connectionRequest": {
            "subject": "You have a tutor request on Athena",
            "body": "{0} wants to connect with you as a tutor.",
            "instructions": "Create or sign in to your Athena account to review the request. You choose whether to accept or decline.",
            "open": "Open Athena"
        }
    },
    "userError": {
        "STUDENT_ALREADY_CLAIMED": "{0} already has an account.",
        "INVITATION_WRONG_ACCOUNT": "This invitation is for a different email address. Sign in with the address your tutor used.",
        "NO_INVITATION": "Open your invitation link again to join.",
        "INVALID_INVITATION": "This invitation is no longer valid.",
        "TUTOR_PROFILE_REQUIRED": "Only a tutor account can accept this invitation.",
        "SUBJECT_UNAVAILABLE": "Choose a subject from the list.",
        "NO_DRAFT": "There are no unpublished changes to publish.",
        "VERSION_IMMUTABLE": "A published version cannot be changed. Edit the practice to start a new draft.",
        "VERSION_NOT_DRAFT": "Only a draft can be published.",
        "DRAFT_MUST_BE_PUBLISHED": "Publish the new version before restoring this practice.",
        "PRACTICE_NOT_ARCHIVED": "Archive this practice before creating a new version.",
        "NO_PUBLISHED_VERSION": "There is no published version to copy.",
        "DRAFT_EXISTS": "This practice already has an editable draft.",
        "INVALID_ANSWER": "Choose exactly one correct answer.",
        "INVALID_ORDER": "Order every option exactly once.",
        "ANSWER_TOO_LONG": "Accepted answers must be three words or fewer.",
        "QUESTION_TOO_FEW_OPTIONS": "This question needs at least two options.",
        "QUESTION_MISSING_ANSWER": "Add at least one accepted answer.",
        "QUESTION_TOO_FEW_PAIRS": "A matching question needs at least two pairs.",
        "LAST_QUESTION": "A practice must keep at least one question.",
        "PRACTICE_NOT_PUBLISHED": "This practice has no published version to attempt.",
        "PRACTICE_ARCHIVED": "This practice has been archived and cannot be started.",
        "PRACTICE_CLOSED": "This practice is no longer available.",
        "MAX_ATTEMPTS_REACHED": "You have used every attempt for this practice.",
        "ATTEMPT_NOT_SUBMITTED": "This attempt has not been submitted yet.",
        "PRACTICE_UNASSIGNED": "This practice is no longer on your list.",
        "ATTEMPTS_REMAINING": "You still have an attempt left at this practice.",
        "ATTEMPT_ALREADY_SUBMITTED": "This attempt has already been submitted.",
        "UNKNOWN_QUESTION": "An answer was sent for a question this practice does not have ({0}).",
        "DUPLICATE_ANSWER": "The same question was answered twice ({0}).",
        "WRONG_ANSWER_SHAPE": "An answer did not match the kind of question it was for ({0}).",
        "OPTION_NOT_IN_QUESTION": "An answer chose an option the question does not have ({0}).",
        "PAIR_NOT_IN_QUESTION": "An answer matched an item the question does not have ({0}).",
        "MATCH_TARGET_NOT_IN_QUESTION": "An answer matched something the question does not offer ({0}).",
        "DUPLICATE_MATCHED_PAIR": "The same item was matched twice ({0}).",
        "DUPLICATE_ORDERED_OPTION": "The same option was placed twice ({0}).",
        "INPUT_TOO_LARGE": "The document is larger than {0} bytes.",
        "MISSING_TITLE": "No single # heading found.",
        "NO_QUESTIONS": "No ## question blocks found.",
        "TOO_MANY_QUESTIONS": "More than {0} questions.",
        "MISSING_PROMPT": "Question {0}: no body text.",
        "MISSING_ANSWER": "Question {0}: no **Answer:** line.",
        "UNKNOWN_QUESTION_TYPE": "Question {0}: \"{1}\" is not a question type.",
        "ANSWER_NOT_IN_OPTIONS": "Question {0}: the answer \"{1}\" does not match an option letter.",
        "MULTIPLE_ANSWERS": "Question {0}: a single-answer question cannot have several answers.",
        "EMPTY_SHORT_ANSWER": "Question {0}: no accepted answers with anything in them.",
        "SHORT_ANSWER_TOO_LONG": "Question {0}: \"{1}\" is too long. A short answer is {2} words at most.",
        "TOO_FEW_OPTIONS": "Question {0}: fewer than {1} options.",
        "TOO_MANY_OPTIONS": "Question {0}: more than {1} options.",
        "DUPLICATE_OPTION_LABEL": "Question {0}: the same option letter twice.",
        "EMPTY_OPTION_TEXT": "Question {0}: option {1} has no text.",
        "DUPLICATE_OPTION_TEXT": "Question {0}: two options both read \"{1}\".",
        "ANSWER_NOT_IN_ORDER": "Question {0}: the answer must list every option letter, in order, such as \"A, C, B, D\".",
        "DUPLICATE_ORDER_ITEM": "Question {0}: the answer names \"{1}\" twice, and each letter belongs exactly once.",
        "INCOMPLETE_ORDER": "Question {0}: the answer leaves out {1}, and each letter belongs exactly once.",
        "MISSING_PAIRS": "Question {0}: a matching question needs \"- left -> right\" lines.",
        "TOO_FEW_PAIRS": "Question {0}: fewer than {1} pairs to match.",
        "TOO_MANY_PAIRS": "Question {0}: more than {1} pairs to match.",
        "EMPTY_PAIR_LEFT": "Question {0}: a pair with nothing on the left of the arrow.",
        "EMPTY_PAIR_RIGHT": "Question {0}: a pair with nothing on the right of the arrow.",
        "DUPLICATE_PAIR_LEFT": "Question {0}: two left items both read \"{1}\".",
        "DUPLICATE_PAIR_RIGHT": "Question {0}: two right items both read \"{1}\".",
        "IMAGE_TOO_LARGE": "One of those images is too large to read. Try a smaller photo.",
        "EXTRACTION_EMPTY": "No text could be read from those images.",
        "EXTRACTION_REFUSED": "Those images could not be read.",
        "EXTRACTION_FAILED": "Athena could not read those images right now. Try again.",
        "EXTRACTION_UNAVAILABLE": "Reading images is not available right now. Write the practice on the Manual tab instead.",
        "GENERATION_UNAVAILABLE": "Creating practices with AI is not available right now. Write the practice on the Manual tab instead.",
        "GENERATION_PROVIDER_OVERRIDE_DISABLED": "Choosing an AI provider is disabled on this server.",
        "GENERATION_PROVIDER_NOT_CONFIGURED": "{0} is not configured on this server.",
        "GENERATION_EMPTY": "Nothing came back. Try again, or write the practice on the Manual tab.",
        "GENERATION_TYPE_MISMATCH": "The generated questions did not match the selected practice type. Try again; no AI credit was used.",
        "GENERATION_REFUSED": "Those pages could not be turned into a practice. Check that they show the material you want questions about.",
        "GENERATION_RATE_LIMITED": "Athena is generating a lot of practices right now. Wait a moment and try again.",
        "GENERATION_TIMEOUT": "That took too long. Try again, or ask for fewer questions.",
        "GENERATION_FAILED": "The practice could not be generated. Try again.",
        "IMAGES_TOO_LARGE": "Those images are too large to read together. Remove a few and try again.",
        "EXTRACTION_INCOMPLETE": "Not every page could be read. Try again.",
        "EXTRACTION_UNREACHABLE": "Athena could not send those images. They may be too large together, or the connection dropped. Try again with fewer pages.",
        "MIXED_SOURCES": "Use images or PDFs for one practice, not both. Remove one kind to continue.",
        "NO_SOURCES": "Add at least one image or PDF first.",
        "PDFS_TOO_LARGE": "Those PDFs are too large to read together. Remove one and try again.",
        "SOURCE_TOO_LARGE": "Those PDFs hold more text than one practice can use. Try fewer of them.",
        "PDF_EMPTY": "{0} is empty.",
        "PDF_UNREADABLE": "{0} could not be opened. Check that the file is a working PDF.",
        "PDF_ENCRYPTED": "{0} is password protected. Remove the password and upload it again.",
        "PDF_NO_TEXT": "{0} has no readable text. Scanned pages and images are not supported — photograph the pages instead.",
        "PDF_TOO_LARGE": "{0} is too large to read.",
        "PDF_FAILED": "{0} could not be read. Try again.",
        "PDF_TOO_MANY_PAGES": "{0} has more than {1} pages. Upload the pages you need as a shorter PDF.",
        "PDF_TIMEOUT": "{0} took too long to read. Try a shorter PDF.",
        "ATTEMPT_EXPIRED": "Time is up for this practice. It has been submitted as it was.",
        "STUDENT_LIMIT_REACHED": "Your plan allows {0} students, and you are using {1}. Set a student aside or request an upgrade.",
        "PRACTICE_LIMIT_REACHED": "Your plan allows {0} active practices, and you have {1}. Archive one or request an upgrade.",
        "QUESTION_LIMIT_EXCEEDED": "Your plan allows {0} questions in a practice, and this one has {1}. Shorten it or request an upgrade.",
        "AI_ALLOWANCE_EXHAUSTED": "You have used all {0} of your AI generations. You can still write a practice on the Manual tab.",
        "EXTRACTION_ALLOWANCE_EXHAUSTED": "You have used all {0} of your AI image readings for now. You can still upload a PDF or write a practice on the Manual tab.",
        "AI_REQUEST_IN_PROGRESS": "Another AI request is still running. Wait for it to finish, then try again.",
        "RATE_LIMITED": "Too many requests in a short time. Try again in {0} minutes.",
        "TIMED_PRACTICE_UNAVAILABLE": "Timed practices are part of the paid plans. Turn off the time limit to save these settings.",
        "TIMED_PRACTICE_UNPUBLISHABLE": "Timed practices are part of the paid plans. Turn off the time limit in the practice settings, then publish.",
        "MULTIPLE_ATTEMPTS_UNAVAILABLE": "Multiple attempts are part of the paid plans. Set the maximum attempts to 1 to save these settings.",
        "PRACTICE_AVAILABILITY_UNAVAILABLE": "Practice availability is part of the paid plans. Remove the end date to save these settings.",
        "SUBSCRIPTION_CHANGED": "This subscription changed while the change was being saved. Nothing was changed; check it and try again.",
        "DETAILED_HISTORY_UNAVAILABLE": "Earlier attempts, answer by answer, are part of the paid plans. Your score is kept.",
        "PRACTICE_SUSPENDED": "This practice was set aside by your plan. Bring it back to use it again.",
        "STUDENT_CONNECTION_SUSPENDED": "This student was set aside by your plan. Bring them back to assign practices.",
        "PRACTICE_OVER_QUESTION_LIMIT": "This practice is longer than the plan allows, so no new attempts can start. It has not been changed.",
        "PRACTICE_TIMED_WITHOUT_PLAN": "This practice is timed, and timed practices are part of the paid plans. Turn off the time limit or request an upgrade.",
        "GENERATION_ALREADY_DELIVERED": "That generation has already run. Ask again to get a new practice.",
        "GENERATION_IN_PROGRESS": "That practice is still being generated. Wait a moment and press Generate practice again; no extra AI credit will be used.",
        "PLAN_NOT_AN_UPGRADE": "That plan is not an upgrade from the one you are on.",
        "PLAN_UNCHANGED": "That is the plan you are already on.",
        "UPGRADE_NEEDS_REQUEST": "Request an upgrade. It is reviewed before it takes effect.",
        "UPGRADE_REQUEST_NOT_PENDING": "That request has already been answered.",
        "NO_SCHEDULED_CHANGE": "There is no scheduled plan change.",
        "SCHEDULED_BY_ADMIN": "Athena scheduled this change to your plan. Contact support to change it.",
        "NO_PAID_ACCESS": "That account has no paid access to end.",
        "INVALID_DOWNGRADE_SELECTION": "Every selected student and practice must be active and belong to you.",
        "DOWNGRADE_SELECTION_TOO_LARGE": "That is more than the new plan holds: {0} students and {1} practices.",
        "INVITATION_NOT_PENDING": "That invitation has already been used or withdrawn.",
        "DECISION_NOTE_REQUIRED": "Write a note explaining the decision.",
        "CONCURRENT_UPDATE": "This record changed while you were editing. Reload it and try again.",
        "RECORD_REFERENCED": "This is still in use and cannot be deleted. Disable the account or deactivate the subject instead.",
        "ROLE_DEPENDENCIES": "This profile has activity or history and cannot be removed.",
        "ADMIN_SELF_PROTECTION": "You cannot disable or delete your own account or remove your own administrator access.",
        "LAST_ADMIN": "The last usable administrator must retain access.",
        "ADMIN_ACCESS_REVOKED": "Your administrative access is no longer available.",
        "ADMIN_PROVISIONING_REQUIRED": "Administrator access is granted with the administrator provisioning command, not from this screen.",
        "STUDENT_INVITATION_REQUIRED": "A student profile is created when the student accepts a tutor’s connection request.",
        "DUPLICATE_EMAIL": "An account already uses this email address.",
        "SUBJECT_CATEGORY_NOT_FOUND": "Subject category not found.",
        "INVALID_SUBJECT_CODE": "Use at least 3 uppercase ASCII letters (A–Z), without numbers, spaces or symbols.",
        "DUPLICATE_SUBJECT_CODE": "A subject already uses this code.",
        "MANAGED_RECORD_NOT_FOUND": "This record no longer exists. Refresh the list.",
        "SUBJECT_TRANSLATIONS_REQUIRED": "Provide valid, non-empty Spanish and English names.",
        "INVALID_MANAGEMENT_INPUT": "Check the fields and try again.",
        "STUDENT_ALREADY_CONNECTED": "This student is already connected to you.",
        "CONNECTION_TUTOR_LIMIT": "This tutor has no available student slots. The request is still pending.",
        "CONNECTION_REQUEST_CLOSED": "This request is no longer pending.",
        "CONNECTION_REQUEST_LIMIT": "You have reached the daily request limit. Try again tomorrow.",
        "LEGACY_LINKS_DISABLED": "Send a connection request from Add student instead.",
        "DELETION_IMPACT_CHANGED": "What this deletion affects changed after you reviewed it. Review the new numbers and confirm again.",
        "GENERATION_QUESTION_TYPES_REQUIRED": "Select at least one question type.",
        "GENERATION_QUESTION_TYPES_PLAN": "Your plan includes multiple choice only. Choose multiple choice or request Premium access.",
        "AI_WEIGHTS_INVALID": "Enter whole percentages from 0 to 100 that sum to 100.",
        "AI_PROVIDER_UNAVAILABLE": "A provider with a positive allocation has no server API key.",
        "AI_CONFIGURATION_CONFLICT": "Configuration changed. Reload and review the new version before saving.",
        "STUDENT_LIMIT_BELOW_USAGE": "The limit cannot be below the {0} occupied or reserved student slots. Free slots first, then try again.",
        "STUDENT_OVERRIDE_REQUIRES_PAID_PLAN": "A custom student limit requires an active paid plan."
    },
    "management": {
        "subjects": "Subjects",
        "createUser": "Create user",
        "createSubject": "Create subject",
        "editUser": "Profile",
        "email": "Email",
        "name": "Name",
        "language": "Preferred language",
        "roles": "Profiles",
        "profilesNone": "No tutor or student profile",
        "profilesTutorStudent": "Tutor and student",
        "profilesHelper": "Student is available only when this account already has a student profile.",
        "sort": "Sort by",
        "newest": "Newest first",
        "code": "Stable code",
        "spanishName": "Spanish name",
        "englishName": "English name",
        "save": "Save changes",
        "dangerZone": "Danger zone",
        "deleteAccount": "Delete account",
        "deleteAccountPermanently": "Permanently delete account",
        "confirmDeleteTitle": "Delete {0} permanently?",
        "confirmDeleteBody": "{0} is deleted with everything it owns: its profiles, its practices and every attempt at them, its subscription and usage, and the audit entries that name it. Other people's accounts stay. This cannot be undone.",
        "confirmDeleteInput": "Type the account’s email to confirm",
        "keepAccount": "Keep account",
        "deleting": "Deleting…",
        "disable": "Disable account",
        "reactivate": "Reactivate account",
        "disableTitle": "Disable {0}?",
        "disableBody": "{0} is signed out everywhere and cannot sign in until the account is reactivated. Their practices, students and history are kept.",
        "keepActive": "Keep account active",
        "reason": "Reason for this change",
        "reasonHelper": "Required. It is recorded in the audit log.",
        "previous": "Previous",
        "next": "Next",
        "page": "{0}–{1} of {2}",
        "saved": "Changes saved.",
        "deletedUser": "Account permanently deleted.",
        "failed": "The change could not be saved. Try again.",
        "emailReadOnly": "The email address cannot be changed here.",
        "createHelp": "New accounts start unverified. They sign in with an emailed code, Google or Microsoft. Creating a student account does not create a student profile or connect a tutor: the student has to accept a tutor’s connection request.",
        "personalDetails": "Personal details",
        "accountSettings": "Account settings",
        "tutorProfile": "Tutor profile",
        "studentProfile": "Student profile",
        "tutorNameHelp": "This name is shown throughout Athena as the tutor’s name.",
        "firstName": "First name",
        "lastName": "Last name",
        "deleteUserEffect": "Permanently deletes {0} and everything only this account owns. This cannot be undone.",
        "deleteSubjectEffect": "Deletes {0} and its names for good. Only a subject no practice uses can be deleted; deactivate one that is in use.",
        "deleteSubject": "Delete subject",
        "deleteSubjectTitle": "Delete {0} permanently?",
        "deleteSubjectBody": "{0} and its Spanish and English names are deleted. Athena refuses if any practice uses it; deactivate it instead. This cannot be undone.",
        "deleteSubjectPermanently": "Delete subject permanently",
        "keepSubject": "Keep subject",
        "subjectEffect": "Inactive subjects cannot be selected for new practices. Existing practices and historical labels remain available.",
        "unsaved": "Discard unsaved changes?",
        "unsavedBody": "Your changes have not been saved. Leaving this page discards them.",
        "keepEditing": "Keep editing",
        "leaveWithoutSaving": "Leave without saving",
        "relationships": "Student’s tutors",
        "codeHelp": "At least 3 uppercase ASCII letters (A–Z) only. Cannot be changed after creation.",
        "usageOther": "{0} practices",
        "usageOne": "1 practice",
        "notSaved": "The change was not saved.",
        "userCreated": "Account created.",
        "deleteUnconfirmed": "Athena could not confirm the account was deleted. Reload the account before trying again.",
        "subjectCreated": "Subject created.",
        "subjectDeleted": "Subject deleted.",
        "roleStudentInvited": "Student (joins by accepting a tutor’s connection request)",
        "featureFlags": "Feature flags",
        "featureFlagsHelp": "Internal capabilities assigned to this account. They take effect on the user’s next request.",
        "practiceProviderOverrideFlag": "Practice-generation provider override",
        "practiceProviderOverrideFlagHelp": "Shows Gemini and OpenAI choices only in this tutor’s Automatic Create Practice flow. The choice applies to one generation request.",
        "localDevelopmentFlag": "Developer diagnostics",
        "localDevelopmentFlagHelp": "Shows the image compression report and extracted text in this user’s Automatic Create Practice flow.",
        "saveFeatureFlag": "Save feature flag",
        "availableFeatureFlags": "Available flags",
        "enabledFeatureFlags": "Enabled flags",
        "addFeatureFlag": "Enable {0}",
        "removeFeatureFlag": "Remove {0}",
        "flagToEnable": "To enable",
        "flagToDisable": "To disable",
        "noEnabledFeatureFlags": "Choose an available flag to enable it.",
        "allFeatureFlagsSelected": "All available flags are selected.",
        "featureFlagsUnsaved": "Unsaved changes. Save to apply this selection.",
        "featureFlagsSelectionHelp": "Changes take effect only after saving.",
        "featureFlagsStale": "This account changed while you were editing. Discard your changes to load the current selection.",
        "saveFeatureFlags": "Save feature flags",
        "resetFeatureFlags": "Discard changes",
        "errors": {
            "reason": "Enter a reason for this change.",
            "name": "Enter a name.",
            "firstName": "Enter a first name.",
            "lastName": "Enter a last name.",
            "email": "Enter a valid email address.",
            "code": "Use at least 3 uppercase ASCII letters (A–Z), without numbers, spaces or symbols.",
            "spanishName": "Enter the Spanish name.",
            "englishName": "Enter the English name.",
            "plan": "Choose a plan.",
            "endDate": "Choose the date paid access ends.",
            "adjustment": "Enter a whole number other than zero.",
            "tooLong": "Keep this to {0} characters or fewer.",
            "confirmEmail": "Type the email exactly as shown: {0}",
            "decisionNote": "Enter a note explaining the decision.",
            "generic": "Check this field."
        },
        "deletionImpact": {
            "loading": "Counting what this deletes…",
            "loadError": "Athena could not count what this deletes. Close this and try again.",
            "deleted": "Permanently deleted",
            "detached": "Kept, with this account removed from them",
            "preserved": "Not affected",
            "otherStudentsTitle": "This also deletes other students’ history",
            "otherStudentsBody": "Other students’ attempts at this tutor’s practices: {0}, from {1} students. Their accounts stay, but these attempts and their scores cannot be recovered.",
            "kinds": {
                "sessions": "Signed-in sessions",
                "providerIdentities": "Google or Microsoft sign-ins",
                "signInCodes": "Unused sign-in codes",
                "featureFlags": "Feature flags",
                "tutorStudentLinks": "Tutor–student connections",
                "connectionRequests": "Connection requests",
                "invitations": "Invitations",
                "provisionalStudents": "Students only this tutor added, who never signed in",
                "practices": "Practices",
                "practiceVersions": "Practice versions",
                "questions": "Questions",
                "assignments": "Assignments",
                "attempts": "Attempts",
                "subscriptions": "Subscription",
                "usagePeriods": "Usage periods",
                "aiUsageEntries": "AI usage records",
                "upgradeRequests": "Upgrade requests",
                "auditEntries": "Audit entries",
                "rateLimitCounters": "Rate-limit counters",
                "upgradeDecisions": "Upgrade requests this administrator answered for other tutors",
                "downgradeSelections": "Other tutors’ downgrade selections",
                "connectedStudents": "Connected students, who keep their accounts",
                "connectedTutors": "Connected tutors, who keep their accounts",
                "sharedProvisionalStudents": "Students other tutors also added"
            }
        }
    },
    "connections": {
        "title": "Requests",
        "pendingTitle": "Pending requests",
        "email": "Student email",
        "emailHelp": "Use the email address the student signs in with. They decide whether to accept your request.",
        "emailError": "Enter a valid email address.",
        "send": "Add student",
        "sent": "Request sent.",
        "alreadyConnected": "Already connected.",
        "pending": "Pending",
        "cancel": "Cancel request",
        "accept": "Accept",
        "decline": "Decline",
        "none": "No pending requests",
        "noneDescription": "New connection requests from tutors will appear here for you to review.",
        "failed": "This request could not be updated. Try again.",
        "accepted": "Request accepted.",
        "declined": "Request declined.",
        "fromTutor": "{0} wants to connect with you as a tutor.",
        "requested": "Requested {0}",
        "nav": "Requests",
        "navCount": "Requests ({0})",
        "notificationFailed": "The request was saved, but the notification email could not be sent. You can cancel and send it again later.",
        "legacyAccept": "Accept invitation",
        "pendingNoSlot": "Pending requests do not use a student slot. A slot is taken only when the student accepts."
    },
    "progressChart": {
        "notIncluded": "Progress over time is part of the paid plans. Every score is still listed below.",
        "title": "Progress over time",
        "viewLabel": "View",
        "viewAttempts": "Attempts",
        "viewDaily": "Daily averages",
        "viewAttemptsHelp": "Each point is one submitted attempt.",
        "viewDailyHelp": "Each point is a subject’s average score for one day (UTC).",
        "subjectFilter": "Subject",
        "everySubject": "All subjects",
        "recentSubjects": "{0} most recent subjects",
        "scopeNote": "Showing the {0} subjects practiced most recently. Choose a subject to see any other.",
        "summary": "{0} in {1}",
        "attemptsOne": "1 attempt",
        "attemptsOther": "{0} attempts",
        "daysOne": "1 daily average",
        "daysOther": "{0} daily averages",
        "subjectsOne": "1 subject",
        "subjectsOther": "{0} subjects",
        "practicesOne": "1 practice",
        "practicesOther": "{0} practices",
        "dailyScope": "{0} across {1}",
        "presentation": "Show progress as",
        "chartTab": "Chart",
        "tableTab": "Table",
        "legendLabel": "Subjects on this chart",
        "labelAttempts": "Scores for {0}, one point per submitted attempt: {1}, on a scale of 0 to 100%.",
        "labelDaily": "Daily average scores for {0}, one point per subject per day: {1}, on a scale of 0 to 100%.",
        "noteAttempts": "A line joins repeated attempts at the same practice. Different practices are not joined: their scores are not directly comparable.",
        "noteDaily": "A line joins one subject’s daily averages. A day’s average can include attempts at different practices.",
        "percent": "{0}%",
        "attemptNumber": "Attempt {0}",
        "dailyAverage": "Daily average",
        "noAttempts": "Scores appear here once {0} submits a practice.",
        "noSubjectData": "No submitted attempts in this subject for this view.",
        "attemptsCaption": "Every attempt on the chart, oldest first",
        "dailyCaption": "Every daily average on the chart, earliest first",
        "columnDate": "Submitted",
        "columnDay": "Day (UTC)",
        "columnSubject": "Subject",
        "columnPractice": "Practice",
        "columnAttempt": "Attempt",
        "columnScore": "Score",
        "columnScope": "Averages",
        "columnAverage": "Average"
    },
    "profile": {
        "title": "My profile",
        "description": "Your name is shared across your Athena profiles."
    },
    "aiAnalytics": {
        "title": "AI Provider Comparison",
        "body": "Compare assigned providers using observed requests. These are descriptive results, not proof of educational correctness.",
        "overview": "Overview",
        "comparison": "Provider comparison",
        "models": "Exact models",
        "trends": "Daily trends (UTC)",
        "diagnostics": "Generation diagnostics",
        "experiment": "Experiment configuration",
        "pricing": "Versioned model pricing",
        "from": "From (YYYY-MM-DD, UTC)",
        "to": "Through (YYYY-MM-DD, UTC)",
        "provider": "Assigned provider",
        "model": "Exact model",
        "operation": "Operation",
        "version": "Configuration version",
        "status": "Status",
        "allocation": "Assignment",
        "all": "All",
        "generation": "Practice generation",
        "extraction": "Image extraction",
        "experimentMode": "Randomized experiment",
        "overrideMode": "Authorized override",
        "defaultMode": "Deployment default",
        "requests": "Requests",
        "successRate": "Success rate",
        "averageLatency": "Average latency",
        "medianLatency": "Median latency",
        "p95Latency": "p95 latency",
        "cost": "Estimated API cost (USD)",
        "costPerSuccess": "Cost per successful practice",
        "inputTokens": "Input tokens",
        "outputTokens": "Output tokens",
        "cachedTokens": "Cached input tokens",
        "reasoningTokens": "Reasoning tokens",
        "totalTokens": "Total tokens",
        "tokensPerPractice": "Average tokens per successful practice",
        "markdownValidity": "Markdown validity",
        "schemaValidity": "Schema validity",
        "questions": "Average generated questions",
        "editRate": "Tutor edit rate",
        "publicationRate": "Publication rate",
        "metric": "Metric",
        "samples": "{0} measured / {1} requests",
        "noData": "No requests match this date range and filters.",
        "unavailable": "Unavailable",
        "latencyUnit": "{0} ms",
        "costCoverage": "Costs cover {0} of {1} requests. Missing estimates are excluded from cost totals.",
        "methodology": "Failed and abandoned requests stay in the denominator. Metrics use original assignment; diagnostics show actual execution. Filter by assignment to separate overrides. Editing measures net changes before first publication; ambiguous replacements are excluded.",
        "qualityNote": "Validation measures format compliance. Duplicate candidates are exact repeated prompts, not proof of duplication. Publication and editing measure tutor behavior, not educational correctness.",
        "quality": "Quality and tutor behavior",
        "missingAnswers": "Missing answers",
        "missingExplanations": "Missing explanations",
        "invalidReferences": "Invalid answer references",
        "malformedQuestions": "Malformed question diagnostics",
        "duplicates": "Duplicate prompt candidates",
        "edited": "Questions edited",
        "deleted": "Questions deleted",
        "added": "Questions added",
        "explanationsEdited": "Explanations edited",
        "optionsEdited": "Options edited",
        "pipelineCost": "Pipeline estimated cost",
        "pipelineLatency": "Average processing time (extraction + generation)",
        "reliability": "Reliability",
        "published": "Published practices",
        "sort": "Sort diagnostics",
        "newest": "Newest first",
        "oldest": "Oldest first",
        "slowest": "Longest duration first",
        "highestCost": "Highest pipeline cost first",
        "timestamp": "Timestamp",
        "executedProvider": "Executed provider",
        "duration": "Duration",
        "questionCount": "Generated questions",
        "errorCategory": "Failure category",
        "details": "Technical details",
        "chartTable": "View daily data",
        "chartLegend": "Providers on this chart",
        "enabled": "Enable experiment",
        "openaiWeight": "OpenAI allocation (%)",
        "geminiWeight": "Gemini allocation (%)",
        "effective": "Effective allocation: OpenAI {0}% / Gemini {1}%, version {2}",
        "configHelp": "Changes take effect on the next admitted request. Disabled uses the deployment default. Positive allocations require server API keys.",
        "invalidWeights": "Enter whole percentages from 0 to 100 that sum to 100.",
        "save": "Save configuration",
        "saved": "Configuration saved",
        "saveError": "The change was not saved. Keep your values and try again.",
        "conflict": "Configuration changed. Reload and review the new version before saving.",
        "reload": "Reload configuration",
        "keyMissing": "A provider with a positive allocation has no server API key.",
        "inputRate": "Input USD / million tokens",
        "outputRate": "Output USD / million tokens",
        "cacheRate": "Cached input USD / million tokens",
        "cacheWriteRate": "Cache write USD / million tokens",
        "priceVersion": "Pricing version",
        "effectiveAt": "Effective from (UTC)",
        "sourceUrl": "Verified pricing source (HTTPS)",
        "registerPrice": "Register pricing",
        "priceSaved": "Pricing registered",
        "priceHelp": "Use the exact response model and verified provider rates. Blank cache rates mean unavailable. New versions affect future requests; historical estimates retain their original rates.",
        "invalidPricing": "Enter a model, version, verified HTTPS source, reason and nonnegative rates.",
        "applyFilters": "Apply filters",
        "invalidDates": "Enter a valid date range of at most 366 days.",
        "pageSummary": "{0} diagnostic records",
        "running": "Running",
        "succeeded": "Succeeded",
        "failed": "Failed",
        "abandoned": "Completion unknown",
        "unknown": "Unknown",
        "abandonedHelp": "A lease expired before a terminal record was saved; usage and latency are unavailable.",
        "errorTimeout": "Timeout",
        "errorRateLimit": "Rate limit",
        "errorRefused": "Provider refusal",
        "errorInvalidResponse": "Invalid response",
        "errorIncomplete": "Incomplete response",
        "errorCancelled": "Cancelled",
        "errorNotConfigured": "Provider unavailable",
        "errorProvider": "Provider error",
        "errorInternal": "Internal failure",
        "errorDelivery": "Draft delivery failed",
        "errorParsing": "Markdown parsing",
        "errorSchema": "Schema validation",
        "errorType": "Question type mismatch",
        "errorLease": "Lease expired",
        "modelNote": "Model comparisons count actual provider attempts. Retries and fallbacks can contribute to more than one model; the provider comparison above counts each logical request once.",
        "errorRecovered": "Terminal status recovered; failure details unavailable",
        "nav": "AI providers",
        "tokensPerRequest": "Average tokens per request",
        "extractionCostPerSuccess": "Cost per successful extraction",
        "extractionTokensPerSuccess": "Average tokens per successful extraction"
    }
}
